var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelCircularIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.28966 12.8947C1.57334 12.2028 1.00197 11.3752 0.608901 10.4602C0.215834 9.54517 0.0089368 8.56102 0.000283176 7.56517C-0.00837045 6.56933 0.181392 5.58173 0.558499 4.66001C0.935606 3.73828 1.4925 2.90089 2.1967 2.1967C2.90089 1.4925 3.73828 0.935606 4.66001 0.558499C5.58173 0.181392 6.56933 -0.00837045 7.56517 0.000283176C8.56102 0.0089368 9.54517 0.215834 10.4602 0.608901C11.3752 1.00197 12.2028 1.57334 12.8947 2.28966C14.2608 3.70418 15.0168 5.59869 14.9997 7.56517C14.9826 9.53165 14.1939 11.4127 12.8033 12.8033C11.4127 14.1939 9.53165 14.9826 7.56517 14.9997C5.59869 15.0168 3.70418 14.2608 2.28966 12.8947ZM8.64216 7.59216L10.7647 5.46966L9.70716 4.41216L7.59216 6.53466L5.46966 4.41216L4.41216 5.46966L6.53466 7.59216L4.41216 9.71466L5.46966 10.7722L7.59216 8.64966L9.71466 10.7722L10.7722 9.71466L8.64966 7.59216H8.64216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircularIcon);
export default __webpack_public_path__ + "static/media/cancelCircularIcon.61daf4688f2e63c0dba3ca73ae6e7988.svg";
export { ForwardRef as ReactComponent };